module.exports = __webpack_public_path__ + "static/img/dba-course02.7d42f3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/personRain/dba-course02.png
// module id = 6Gn0
// module chunks = 2